import { Badge } from "antd";
import { LOCATION_TYPE } from "../../domain/notes.domain";

type Props = {
  location_type?: number | null | undefined;
  isStyled?: boolean;
  isBadge?: boolean;
};

export default function LocationType({ location_type, isStyled = true, isBadge = false }: Props) {
  const style = { color: "#1E3A8A", fontSize: "14px", fontWeight: "500" };
  if (location_type === LOCATION_TYPE.TELEHEALTH)
    return isBadge ? (
      <Badge count={"Telehealth"} showZero className="badge-default" />
    ) : (
      <span style={isStyled ? style : {}}>Telehealth</span>
    );
  if (location_type === LOCATION_TYPE.IN_PERSON)
    return isBadge ? (
      <Badge count={"In-person"} showZero className="badge-default" />
    ) : (
      <span style={isStyled ? style : {}}>In-person</span>
    );
  return <></>;
}
